import privateRequest from "./privateRequest";

const getUserDetails = (portalId) => (userId) =>
  privateRequest({ route: "/portal/user/details", data: { portalId, userId }, useAPI: false });

export default getUserDetails;
